import React, {useState, useEffect} from 'react'
import styled from "@emotion/styled";
import {Box, CircularProgress} from '@mui/material';
import BtnPrimary from '../../../../../../../component/PrimaryButton';
import BtnSecondary from '../../../../../../../component/SecondaryButton';
import GoogleMapWithPolyline from '../../../../../../../component/GoogleMapPolyline';
import {getTripById } from '../../../../../../../services/trips';
import ActionDialog from '../../../../../../../component/ActionDialog';
import {approveExpense, getExpenseById, rejectExpense } from '../../../../../../../services/expense';
import CloseIcon from '@mui/icons-material/Close';
import { useOrgEmployees } from '../../../../../../../services/useOrgData';
import { useNotify } from '../../../../../../../component/NotificationProvider';

import { displayFont } from "../../../../../../../theme";
import { tokens } from "../../../../../../../theme";
const LabelBox = styled(Box)({
    fontSize: "0.875rem",
    color: tokens.pendingText,
    lineHeight: 1.6,
});

const ValueBox = styled(Box)({
    fontSize: "1rem",
    color: "#2A1D22",
    lineHeight: 1.7,
});

const TripInfo = ({tripId, expenseId, setOpen}) => {

const notify = useNotify();
const { data: employees } = useOrgEmployees();
const [tripDetails, setTripDetails] = useState([
    { label: "Trip ID", value: "" },
    { label: "Start Date", value: "" },
    { label: "End Date", value: "" },
    { label: "Total Distance", value: "" },
    { label: "Reporting Manager", value: "" },
    { label: "Trip Policy", value: "" },
    { label: "Vehicle Type", value: "" },
    { label: "Reason", value: "" }
  ]);
 const [loading, setLoading] = useState(false);
 const [startLocation,setStartLocation] = useState(null);
 const [endLocation,setEndLocation] = useState(null);
 const [middleLocations,setMiddleLocations] = useState(null);
 const [approveDialogOpen, setApproveDialogOpen] = useState(false);
 const [rejectDialogOpen, setRejectDialogOpen] = useState(false);
 const [status,setStatus] = useState("");
 const [employee,setEmployee] = useState({});

  useEffect(() => {
      if(tripId)
        fetchTripDetails();
  }, [tripId]);

  const fetchTripDetails = async () => {
    setLoading(true);
    try {
      const res = await getTripById(tripId);
      const res2 = await getExpenseById(expenseId);
      const tripData = res?.data;
      const expenseData = res2?.data;
      const employeeList = employees || [];
      const approverIds = expenseData?.policy?.approverIds || [];
      const approvers = employeeList.filter(emp => approverIds.includes(emp._id));
      setStatus(expenseData?.status);
      setEmployee(employeeList.find(emp=>emp._id===expenseData?.submitterId));
      setTripDetails([
        { label: "Trip ID", value: tripData?.aliasId },
        { label: "Start Date", value: new Date(tripData?.startTime).toLocaleDateString('en-GB')},
        { label: "End Date", value: new Date(tripData?.endTime).toLocaleDateString('en-GB')},
        { label: "Total Distance", value: `${tripData?.distance || 0} KM` },
        { label: "Reporting Manager", value: approvers?.length > 0 
          ? approvers?.map(approver => `${approver?.fname} ${approver?.lname}`).join(', ')
          : '--'},
        { label: "Trip Policy", value: expenseData?.policy?.name},
        { label: "Vehicle Type", value: expenseData?.policyCateogary?.name },
        { label: "Reason", value: expenseData?.reason }
      ]);
      setStartLocation(tripData?.startLocation);
      setEndLocation(tripData?.endLocation);
      setMiddleLocations(tripData?.middleLocations);
    } catch (error) {
      notify.error(error?.message || "Failed to load trip details");
    } finally {
      setLoading(false);
    }
  };


  const handleReject = () => {
    setRejectDialogOpen(true);
  };

  const handleApprove = async() => {
    setApproveDialogOpen(true);
  };

  const handleCloseRejectDialog = () => {
    setRejectDialogOpen(false);
  };
  
  const handleCloseApproveDialog = () => {
    setApproveDialogOpen(false);
  };

  return (
    loading?(
      <Box sx={{width:"25.5rem",display:"flex", justifyContent:"center", alignItems:"center", height:"100vh"}}>
        <CircularProgress/>
      </Box>
    ):(
    <Box sx={{width:"25.5rem", backgroundColor:"#F5E9E1",borderRadius:"12px",padding: "1.5rem"}}>
          <Box sx={{display:"flex",justifyContent:"space-between"}}>
              <Box sx={{fontWeight: 600,fontFamily: displayFont, fontSize:"1.25rem",lineHeight: 1.3,color:"#2A1D22"}}>
                Trip Details
              </Box>
              <CloseIcon 
                fontSize='small' 
                onClick={()=>setOpen(false)} 
                sx={{
                  "&:hover": {
                    cursor: "pointer",
                  },
                }}/>
          </Box>
          <Box sx={{display:"flex",justifyContent:"space-between",fontWeight:400,fontSize:"0.875rem",lineHeight: 1.6}}>
              <Box>
                  <Box sx={{color:"#2A1D22"}}>{employee?.fname+" "+employee?.lname}</Box>
                  <Box sx={{color:"#8C3B5E"}}>{employee?.designation}</Box>
              </Box>
              <Box sx={{
                        alignSelf:"end",
                        borderRadius: "6px", 
                        padding: "4px 8px",
                        textAlign:"center",
                        backgroundColor: status === "pending" ? tokens.textMuted : (status === "rejected" ? tokens.dangerTint : tokens.successText),
                        color: status === "pending" ? tokens.text : (status === "rejected" ? tokens.danger : tokens.onPrimary)
                      }}>
                  {status}
              </Box>
          </Box>
          <Box sx={{display:"flex", flexDirection:"column", gap: "1rem", marginTop: "1.5rem"}}>
                {tripDetails.map((item, index) => (
                    <Box
                      key={index}
                      sx={{ display: "flex", justifyContent: "space-between"}}
                    >
                      <LabelBox>{item?.label}</LabelBox>
                      <ValueBox>{item?.value}</ValueBox>
                    </Box>
                  ))}
          </Box>
          <Box>
            <GoogleMapWithPolyline 
                startLocation={startLocation}
                endLocation={endLocation}
                middleLocations={middleLocations}
            />
          </Box>
          {
            status==="pending"?
              <Box sx={{ width:"100%", display: "flex", gap: "1rem", marginBlock: "2rem" }}>
                <BtnSecondary onClick={handleReject} sx={{ borderRadius: "8px", flex:"1" }}>
                    Reject
                </BtnSecondary>
                <BtnPrimary onClick={handleApprove} sx={{ borderRadius: "8px",flex:"1" }}>
                    Approve
                </BtnPrimary>
              </Box>
            :null
          }
          <ActionDialog 
            type="approve" 
            open={approveDialogOpen} 
            onClose={handleCloseApproveDialog} 
            reviewApi={approveExpense}
            id={expenseId} 
            text="Approve Trip?"
          />
          <ActionDialog 
            type="reject" 
            open={rejectDialogOpen} 
            onClose={handleCloseRejectDialog} 
            reviewApi={rejectExpense}
            id={expenseId}
            text="Reject Trip?"
          />
    </Box>
   )
  )
}

export default TripInfo